import { render, staticRenderFns } from "./leistungen-software-1.vue?vue&type=template&id=b10f8ac0&"
import script from "./leistungen-software-1.vue?vue&type=script&lang=js&"
export * from "./leistungen-software-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports